import { Event } from 'src/WebApiController';

export const getIsPlaceholderEvent = (event: Event): boolean => {
  const { viagId, mpId, virtId } = event;
  return viagId === null && mpId !== null && mpId === virtId;
};
